import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux"; // Import Provider
import store, { persistor } from "./store"; // Import your Redux store
import "./main.css";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./helpers/queryClient.ts";
import CustomPersistGate from "./components/CustomPersistGate.tsx";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://09f7c04b0d8692b26abf6df4eeec1569@o4506797625966592.ingest.us.sentry.io/4510453817868288",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/energovizor\.cz\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  sendDefaultPii: true,
  enableLogs: true
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <CustomPersistGate persistor={persistor} />
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
